import { ActionTree } from 'vuex';
import { IRootState } from '../root-state.store';
import { IBlockState } from './block-state.store';
import {
  BLOCK_GET_BLOCKS_MASTER, BLOCK_LOADING, BLOCK_SET_BLOCKS, BLOCK_GET_BLOCKS,
  BLOCK_APARTMENT_SIDEBAR_GET_TICKETS,
  BLOCK_APARTMENT_SIDEBAR_SET_TICKETS,
  BLOCK_GET_BLOCK, BLOCK_SET_BLOCK, BLOCK_DETAIL_LOADING,
  BLOCK_GET_BLOCKS_AUTOCOMPLETE,
  BLOCK_GET_DETAIL_STATISTIC,
  BLOCK_GET_DETAIL_STATISTIC_LOADING,
  GET_BLOCKS_BY_TETANT,
  BLOCK_RESET, BLOCK_INIT,
  BLOCK_RECORD,
  BLOCK_GET_BLOCKS_BYQUERY,
  BLOCK_UPDATE,
  BLOCK_DELETE,
  BLOCK_EDIT_BLOCK,
  BLOCK_ACTION,
  BLOCK_GET_BLOCKS_BY_ID
} from './block-types.store';
import { ActivityStatus, UserTypes, CrudStatus } from '../../common/enums';
import { ITicketParameter } from '../../models/ticket';
import { IBlockParameter, IBlock, IBlockListingViewModel } from '../../models/block';
import { IBlockService } from '../../services';
import { AddressDto } from '../../models/address/address.model';

export const actions: ActionTree<IBlockState, IRootState> = {

  [BLOCK_GET_BLOCKS_MASTER]: async ({ state, commit, rootGetters }, param: any) => {
    if (rootGetters['user/userInfo'] && rootGetters['user/userInfo'].type !== UserTypes.Manager) {
      if (rootGetters['user/userInfo'].blocks) {
        commit(BLOCK_SET_BLOCKS, {
          activityStatus: ActivityStatus.Loaded,
          blocks: rootGetters['user/userInfo'].blocks || []
        });
        return Promise.resolve(rootGetters['user/userInfo'].blocks)
      }
    }

    commit(BLOCK_LOADING, ActivityStatus.Loading)

    return state.service.getBlocks(param)
      .then(blocks => {
        commit(BLOCK_SET_BLOCKS, {
          activityStatus: ActivityStatus.Loaded,
          blocks
        })
        return Promise.resolve(blocks);
      })
      .catch(error => {
        commit(BLOCK_LOADING, ActivityStatus.LoadFailed)
        return Promise.reject(error)
      })
  }
  , [BLOCK_RESET]: ({ commit, state }) => {
    const service: IBlockService = state.service
    commit(BLOCK_INIT, service.initBlock());
    commit(BLOCK_ACTION,CrudStatus.NoAction)
  }
  , [BLOCK_EDIT_BLOCK] : ({commit, getters}) => {
      const service: IBlockService= getters.service
      const currentBlock: IBlockListingViewModel = getters.currentBlock
      console.log('current block=',currentBlock)
      commit(BLOCK_ACTION,CrudStatus.Update)
      commit(BLOCK_INIT,service.initBlock({
        name: currentBlock.name,
        address: currentBlock.address ? new AddressDto(currentBlock.address) : new AddressDto,
        digicode: currentBlock.digicode,
        nbreLots: currentBlock.number_apartments,
        concierge: currentBlock.caretakers.map(item=> item.id),
        managers: currentBlock.managers.map(item=> item.id),
        commercial: currentBlock.salespersons.map(item=>item.id)
      }))
  }
  , [BLOCK_RECORD] : ({ commit, getters }, payload: {} ) => {
      const service : IBlockService  = getters.service
      return service.recordBlock(getters.block)
        .then(( recordedBlock: IBlock ) => Promise.resolve(recordedBlock))
        .catch(error=> Promise.reject(error))
        .finally(()=> commit(BLOCK_INIT, service.initBlock()))
  }
  , [BLOCK_UPDATE] : ({ commit, getters }, payload: {}) => {
    const service: IBlockService = getters.service
    const block : IBlock = getters.block
    return service.updateBlock(getters.currentBlock.id,block)
        .then( (updatedBlock : IBlock ) =>{
          commit(BLOCK_INIT,service.initBlock())
          commit(BLOCK_ACTION,CrudStatus.NoAction)
          return Promise.resolve(updatedBlock)
        })
        .catch( error => Promise.reject(error))
  }
  , [BLOCK_DELETE] : ({ commit, getters }) => {
     const service: IBlockService = getters.service
     const blockId: number= getters.currentBlock.id
     return service.deleteBlock(blockId)
        .then(( deletedBlock: IBlock ) => Promise.resolve(deletedBlock))
        .catch(err => Promise.reject(err))
        .finally(()=>{
          commit(BLOCK_ACTION,CrudStatus.NoAction)
        })
  }
  , [BLOCK_GET_BLOCKS]: async ({ state, commit, getters }, payload: { param: IBlockParameter, merge?: boolean }) => {
    if (state.activityStatus === ActivityStatus.Loading) return;

    commit(BLOCK_LOADING, ActivityStatus.Loading)
    return state.service.getBlocks(payload.param, true)
      .then(rawData => {
        commit(BLOCK_SET_BLOCKS, {
          blocks: rawData.data,
          pagination: { total: rawData.total, skip: rawData.skip, limit: rawData.limit },
          merge: payload.merge
        })
        return Promise.resolve(rawData.data);
      })
      .catch(error => {
        commit(BLOCK_LOADING, ActivityStatus.LoadFailed)
        return Promise.reject(error)
      })
  }
  , [BLOCK_GET_BLOCK]: async ({ state, commit }, blockId: string) => {

    // const blockIdInt: number = parseInt(blockId);
    // if (isNaN(blockIdInt)) return;
    // if (state.currentBlock && blockIdInt === state.currentBlock.id) return;
    if (state.detailActivityStatus === ActivityStatus.Loading) return;
    commit(BLOCK_DETAIL_LOADING, ActivityStatus.Loading)


    return state.service.getBlockDashboardById(blockId)
      .then(block => {
        commit(BLOCK_SET_BLOCK, block);
        return Promise.resolve(block);
      })
      .catch(error => {
        commit(BLOCK_LOADING, ActivityStatus.LoadFailed);
        return Promise.reject(error)
      })
  }
  , [BLOCK_APARTMENT_SIDEBAR_GET_TICKETS]: async ({ state, rootGetters, commit }, payload: { storeKey?: string, ticketParameter: ITicketParameter }) => {

    return rootGetters['ticket/service'].getTickets(payload.ticketParameter)
      .then(tickets => {
        commit(BLOCK_APARTMENT_SIDEBAR_SET_TICKETS, {
          key: payload.storeKey ? payload.storeKey : 'blockApartmentTickets',
          ticketRawData: tickets
        })
        return tickets;
      })
      .catch(error => console.log(error))
  }
  , [BLOCK_GET_BLOCKS_AUTOCOMPLETE]: async ({ state, commit }, param: IBlockParameter) => {

    if (state.activityStatus === ActivityStatus.Loading) return;
    commit(BLOCK_LOADING, ActivityStatus.Loading)
    return state.service.getBlocks(param, false)
      .then(blocks => {
        commit(BLOCK_LOADING, ActivityStatus.Loaded)
        return Promise.resolve(blocks);
      })
      .catch(error => {
        commit(BLOCK_LOADING, ActivityStatus.LoadFailed)
      })
  }
  , [BLOCK_GET_BLOCKS_BYQUERY]: async ({ state, commit }, query: string )=>{
    return state.service.getBlocks({ key: query },false)
        .then(blocks => Promise.resolve(blocks))
        .catch(err=> Promise.reject(err))
  }
  , [BLOCK_GET_DETAIL_STATISTIC]: async ({ state, commit }, payload: { blockId: string, start: string, end: string }) : Promise<any> => {

    return state.service.getBlockDetailStatistic(payload.blockId, payload.start, payload.end)
      .then(statisticData => {
        commit(BLOCK_GET_DETAIL_STATISTIC, statisticData)
        return Promise.resolve(statisticData);
      })
      .catch(error => {
        commit(BLOCK_GET_DETAIL_STATISTIC_LOADING, ActivityStatus.LoadFailed)
      })
  }
  , [GET_BLOCKS_BY_TETANT]: async ({ state, commit }, entityId: number) => {
    return await state.service!.getBlockByTenantId(entityId)
      .then(res => res)
      .catch(error => {
        console.log(error, 'error');
        return Promise.reject(error)
      })
  },
  [BLOCK_GET_BLOCKS_BY_ID]: async ({ state, commit }, id: string )=>{
    return state.service.getBlockById(id)
        .then(blocks => Promise.resolve(blocks))
        .catch(err=> Promise.reject(err))
  }

}



// WEBPACK FOOTER //
// ./src/store/block/block-actions.store.ts